/* eslint-disable no-undef */

export function showOverlay(config) {
  if (document.getElementById('tpx-display-overlay-container')) {
    document.getElementById('tpx-display-overlay-container').style.visibility = 'visible';
    setTimeout(() => {
      document.getElementById('tpx-overlay-close').style.visibility = 'visible';
    }, 2000);
    const playerComp = document.getElementById(config.targetId);
    document.getElementById('tpx-display-overlay-container').style.scale =
      playerComp.clientWidth < 319 ? playerComp.clientWidth / 320 - 0.05 : 1;
  }
}

export function hideOverlay() {
  if (document.getElementById('tpx-display-overlay-container')) {
    document.getElementById('tpx-display-overlay-container').style.visibility = 'hidden';
    document.getElementById('tpx-overlay-close').style.visibility = 'hidden';
  }
}
